import {
    Box,
    Paper,
    Grid,
    MenuItem,
    TextField,
    Typography,
    Button,
    Stack,
    Alert
} from "@mui/material";
// import { useContext } from "react";
// import { UserContext } from "../../context/UserContext";

import { useEffect, useState } from "react";

import { getInstalledPrinters } from "../../utils/qzPrinter";

import { getPrinterSettings, savePrinterSettings } from "../../utils/printerStorage";

import Custom_Select from "../custom_components/CustomSelect";
import Custom_Button from "../custom_components/CustomButton";

import { initializeQZ } from "../../utils/qzPrinter";

export default function PrinterSettings() {

    // const { printerNames, setPrinterNames } = useContext(UserContext);

    const [printers, setPrinters] = useState([]);

    const [settings, setSettings] = useState(getPrinterSettings());

    const [saved, setSaved] = useState(false);

    useEffect(() => {
        const loadPrinters = async () => {
            const printerList = await initializeQZ();

            setPrinters(printerList);
        };

        loadPrinters();
    }, [setPrinters]);

    const handleChange = (field, value) => {
        setSettings((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSave = () => {
        savePrinterSettings(settings);

        setSaved(true);

        setTimeout(() => {
            setSaved(false);
        }, 3000);
    };

    return (
        <Box
            sx={{
                p: 3,
                maxWidth: 800,
                mx: "auto"
            }}
        >
            <Typography
                variant="h6"
                fontWeight={600}
                mb={3}
            >
                Printer Settings
            </Typography>

            {saved && (
                <Alert
                    severity="success"
                    sx={{ mb: 2 }}
                >
                    Printer settings saved.
                </Alert>
            )}

            <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Custom_Select
                        label="Receipt Printer"
                        value={settings.receiptPrinter || ""}
                        minWidth={180}
                        onChange={(e) => handleChange("receiptPrinter", e)}
                        options={[
                            ...(settings.receiptPrinter &&
                                !printers?.includes(settings.receiptPrinter)
                                ? [{
                                    label: settings.receiptPrinter,
                                    value: settings.receiptPrinter
                                }]
                                : []),

                            ...(printers?.map((printer) => ({
                                label: printer,
                                value: printer
                            })) || [])
                        ]}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>
                    <Custom_Select
                        label="Label Printer"
                        value={settings.labelPrinter || ""}
                        minWidth={180}
                        onChange={(e) => handleChange("labelPrinter", e)}
                        options={[
                            ...(settings.labelPrinter &&
                                !printers?.includes(settings.labelPrinter)
                                ? [{
                                    label: settings.labelPrinter,
                                    value: settings.labelPrinter
                                }]
                                : []),

                            ...(printers?.map((printer) => ({
                                label: printer,
                                value: printer
                            })) || [])
                        ]}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>
                    <Custom_Select
                        label="Default Printer"
                        value={settings.defaultPrinter || ""}
                        minWidth={180}
                        onChange={(e) => handleChange("defaultPrinter", e)}
                        options={[
                            ...(settings.defaultPrinter &&
                                !printers?.includes(settings.defaultPrinter)
                                ? [{
                                    label: settings.defaultPrinter,
                                    value: settings.defaultPrinter
                                }]
                                : []),

                            ...(printers?.map((printer) => ({
                                label: printer,
                                value: printer
                            })) || [])
                        ]}
                    />
                </Grid>

            </Grid>

            <Stack
                direction="row"
                justifyContent="flex-end"
                mt={3}
            >
                <Custom_Button
                    variant="contained"
                    label="Save Settings"
                    onClick={handleSave}
                />
            </Stack>
        </Box>
    );
}